module.exports = __webpack_public_path__ + "static/zem100l-74ae82be24d1946d03bb340c094d7cd5.png";